import { mapGetters, mapActions, mapMutations } from 'vuex'
import moment from 'moment'

export default {
  props: {
    value: {
      required: true,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      headersPLD: [
        { text: 'Data', align: 'left', value: 'dateAndTime' },
        { text: 'Nome', align: 'left', value: 'userName' },
        { text: 'Comentário', align: 'left', value: 'text' }
      ],
      text: '',
      dialog: false,
      isLoading: false
    }
  },
  computed: {
    ...mapGetters([
      'getterAccount',
      'getterSelectedCallManager',
      'getterPld'
    ]),
    getAtualDate () {
      return moment().format('L')
    },
    options () {
      return {
        loading: this.isLoading
      }
    }
  },
  mounted () {
    this.dialog = true
  },
  beforeDestroy () {
    this.SET_ALL_PLD_BY_CALL_MANAGER()
    this.SET_SELECTED_CALL_MANAGER()
  },
  methods: {
    ...mapActions([
      'actionPostComment'
    ]),
    ...mapMutations([
      'SET_ALL_PLD_BY_CALL_MANAGER',
      'SET_SELECTED_CALL_MANAGER'
    ]),
    closeModal () {
      this.isLoading = this.dialog = false

      setTimeout(() => {
        this.$emit('input', false)
      }, 300)
    },
    generateComment () {
      const params = {
        dateAndTime: new Date(),
        text: this.text,
        userName: this.getterAccount.userName,
        idCallManager: this.getterSelectedCallManager.idCallManager,
        type: 'Portal Data Engine'
      }

      this.isLoading = true

      this.actionPostComment(params)
        .then(() => {
          this.sendToast({
            text: 'Comentário salvo!',
            type: 'success'
          })

          this.text = ''
          this.isLoading = false
        })
        .catch(() => {
          this.sendToast({
            text: 'Não foi possível salvar comentário!',
            type: 'danger'
          })

          this.isLoading = false
        })
    }
  }
}
